const menu = [
  {
    name: "sidebar.home",
    icon: "tim-icons icon-bank",
    path: "/home"
  },
  {
    name: "sidebar.funcionarios",
    icon: "tim-icons icon-badge",
    children: [
      {
        name: "sidebar.pesquisarEmpregados",
        path: "/pesquisarEmpregados"
      },
      { name: "sidebar.confEscalas", path: "/confEscalas" },
      {
        name: "sidebar.pesquisarEscalaDepartamento",
        path: "/pesquisarEscalaDepartamento"
      },
      {
        name: "sidebar.funcionariosDemitidos",
        path: "/funcionariosDemitidos"
      },
      {
        name: "sidebar.pesquisarFerias",
        path: "/pesquisarFerias"
      },
      {
        name: "sidebar.fichaFuncionarios",
        path: "/fichaFuncionarios"
      }
    ]
  },
  {
    name: "sidebar.tiposDeAbono",
    icon: "tim-icons icon-check-2",
    path: "/pesquisarAbonos"
  },
  {
    name: "sidebar.Holerite",
    icon: "tim-icons icon-paper",
    children: [
      {
        name: "sidebar.EnviosHolerite",
        icon: "tim-icons icon-paper",
        path: "/enviosHolerite"
      },
      {
        name: "sidebar.EnviosHoleriteIndividual",
        icon: "tim-icons icon-paper",
        path: "/enviosHoleriteIndividual"
      },
      {
        name: "sidebar.ListaHoleriteParaLiberacao",
        icon: "tim-icons icon-paper",
        path: "/listaHoleriteParaLiberacao"
      }
    ]
  },
  {
    name: "sidebar.feriados",
    icon: "tim-icons icon-calendar-60",
    path: "/feriados"
  },
  {
    name: "sidebar.usuarios",
    icon: "tim-icons icon-single-02",
    children: [
      {
        name: "sidebar.usuarios_lista",
        path: "/usuarios"
      },
      {
        name: "sidebar.perfis_lista",
        path: "/usuarios/perfis"
      }
    ]
  },
  {
    name: "sidebar.relatoriosGerenciais",
    icon: "tim-icons icon-paper",
    children: [
      {
        name: "sidebar.entradasSaidas",
        path: "/entradasSaidas"
      },
      {
        name: "sidebar.relatorioFuncionario",
        path: "/relatorioFuncionario"
      },
      {
        name: "sidebar.painelEscala",
        path: "/painelEscala"
      },
      // {
      //   name: "sidebar.relatorioDivergenciaEscalaModelo",
      //   path: "/relatorioDivergenciaEscalaModelo"
      // },
      {
        name: "sidebar.listagemQrPonto",
        path: "/listagemQrPonto"
      },
      {
        name: "sidebar.listagemCoordenadasGps",
        path: "/listagemCoordenadasGps"
      },
      {
        name: "sidebar.relatorioSintetico",
        path: "/relatorioSintetico"
      },
      {
        name: "sidebar.relatorioAniversariantes",
        path: "/relatorioAniversariantes"
      },
      {
        name: "sidebar.relatorioAbonos",
        path: "/relatorioAbonos"
      },
      {
        name: "sidebar.relatorioAbsenteismo",
        path: "/relatorioAbsenteismo"
      },
      {
        name: "sidebar.relatorioAdiantamento",
        path: "/relatorioAdiantamento"
      },
      {
        name: "sidebar.relatorioApuracaoFaltas",
        path: "/relatorioApuracaoFaltas"
      },
      {
        name: "sidebar.relatorioBeneficios",
        path: "/relatorioBeneficios"
      },
      {
        name: "sidebar.relatorioFaltas",
        path: "/relatorioFaltas"
      },
      {
        name: "sidebar.relatorioAssinaturas",
        path: "/relatorioAssinaturas"
      },
      {
        name: "sidebar.RelatorioDeAssinaturaHolerite",
        icon: "tim-icons icon-paper",
        path: "/relatorioDeAssinaturaHolerite"
      }
    ]
  },
  {
    name: "sidebar.grafricos",
    icon: "tim-icons icon-chart-bar-32",
    children: [
      {
        name: "sidebar.graficoResumoAnalitico",
        path: "/graficoResumoAnalitico"
      },
      {
        name: "sidebar.graficoJornadaTrabalho",
        path: "/graficoJornadaTrabalho"
      }
    ]
  },
  {
    name: "sidebar.pontos",
    icon: "tim-icons icon-pin",
    children: [
      {
        name: "sidebar.assinatura_ponto",
        path: "/assinatura_ponto"
      },
      {
        name: "sidebar.fecharFolha",
        path: "/enviarAssinatura"
      }
    ]
  },
  {
    name: "sidebar.atestadoTecnico",
    icon: "tim-icons icon-notes",
    path: "/atestadoTecnico"
  },
  {
    name: "sidebar.exportacao",
    icon: "tim-icons icon-cloud-download-93",
    children: [
      {
        name: "sidebar.exportacao_AFD",
        path: "/exportacaoAFD"
      },
      {
        name: "sidebar.exportacao_AFDT",
        path: "/exportacaoAFDT"
      },
      {
        name: "sidebar.exportacao_ACJEF",
        path: "/exportacaoACJEF"
      },
      {
        name: "sidebar.exportacao_AEJ",
        path: "/exportacaoAEJ"
      },
      {
        name: "sidebar.exportacao_Folha",
        path: "/exportacaoFolha"
      },
      {
        name: "Configuração Rubricas",
        path: "/configurarRubricaFolha"
      }
    ]
  },
  {
    name: "sidebar.importacao",
    icon: "tim-icons icon-cloud-download-93",
    children: [
      {
        name: "sidebar.importacao_AFD",
        path: "/afdRelogios"
      },
      {
        name: "sidebar.importacao_control",
        path: "/controlId"
      }
    ]
  },
  {
    name: "sidebar.solicAbono",
    icon: "tim-icons icon-chat-33",
    path: "/notificacoesAbonos"
  }
];

export default {
  KEY_LEVEL_1: "xywWhTaLoJ",
  KEY_LEVEL_3: "pxQTvzjXxM",
  KEY_LEVEL_5: "qtOsEEpdjP",
  KEY_LEVEL_7: "PsmMjKlqhz",
  KEY_LEVEL_10: "jwiSkAZpqg",
  menu
};
